<script lang="ts">
  import type { Snippet } from 'svelte'

  type Props = {
    children: Snippet
  }

  let { children }: Props = $props()
</script>

<p class="input-label">{@render children?.()}</p>

<style lang="scss">
  .input-label {
    color: var(--right-bar-muted-foreground);
    font-size: 0.75rem;
    line-height: 100%;
  }
</style>
